var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlatePause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 31,
    viewBox: "0 0 51 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.855469H50.4348V26.3627C50.4348 28.924 48.3584 31.0004 45.7971 31.0004H4.63768C2.07636 31.0004 0 28.924 0 26.3627V0.855469Z",
    fill: "#44A6EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.08373C20 6.97916 20.8954 6.08373 22 6.08373H22.1667C23.2712 6.08373 24.1667 6.97916 24.1667 8.08373V14.9171C24.1667 16.0216 23.2712 16.9171 22.1667 16.9171H22C20.8954 16.9171 20 16.0216 20 14.9171V8.08373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 8.08373C25.8333 6.97916 26.7288 6.08373 27.8333 6.08373H28C29.1046 6.08373 30 6.97916 30 8.08373V14.9171C30 16.0216 29.1046 16.9171 28 16.9171H27.8333C26.7288 16.9171 25.8333 16.0216 25.8333 14.9171V8.08373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlatePause);
export default __webpack_public_path__ + "static/media/slate_pause.bddb4ba987f9c4ef48404adda5f9c2be.svg";
export { ForwardRef as ReactComponent };